import React from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Layout, BookOpen, PenTool, LogOut, MessageCircle, BarChart2 } from 'lucide-react'; // Import Lucide icons and added BarChart2 icon
import '../styles/sidebar.css';
                  


const Sidebar = ({ isOpen, onToggle, onLogout }) => {
  const location = useLocation();
  const navigate = useNavigate();

  // If we're on the login page, don't render the sidebar
  if (location.pathname === '/login') {
    return null;
  }

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      // Clear authentication state
      localStorage.setItem('isAuthenticated', 'false');
      localStorage.removeItem('user');
      
      // Call the onLogout prop
      onLogout();
      
      // Navigate to login
      navigate('/login');
    }
  };

  const getActiveItem = () => {
    switch (location.pathname) {
      case '/learn':
        return 'courses';
      case '/':
        return 'dashboard';
      case '/quiz':
        return 'quiz';
      case '/doubts':
        return 'doubts';
      case '/analytics':
        return 'analytics';
      default:
        return '';
    }
  };

  return (
    <>
      <button 
        className="sidebar-toggle" 
        onClick={onToggle}
        aria-label="Toggle menu"
      >
        {isOpen ? (
          <svg viewBox="0 0 24 24" className="close-icon">
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" className="menu-icon">
            <path d="M3 12h18M3 6h18M3 18h18" />
          </svg>
        )}
      </button>

      {isOpen && (
        <div className="sidebar-overlay" onClick={onToggle}></div>
      )}

      <div className={`sidebar ${isOpen ? 'active' : ''}`}>
        <div className="sidebar-header">
          <img src="/cmpnylogo.jpg" alt="Logo" className="sidebar-logo" />
          <h3 className="sidebar-title">Immersive Technology</h3>
        </div>

        <ul className="sidebar-menu">
          <li className={`sidebar-item ${getActiveItem() === 'dashboard' ? 'active' : ''}`}>
            <Link to="/" className="sidebar-link" onClick={onToggle}>
              <Layout className="sidebar-icon" />
              <span className="sidebar-text">Dashboard</span>
            </Link>
          </li>

          <li className={`sidebar-item ${getActiveItem() === 'analytics' ? 'active' : ''}`}>
            <Link to="/analytics" className="sidebar-link" onClick={onToggle}>
              <BarChart2 className="sidebar-icon" />
              <span className="sidebar-text">My Analytics</span>
            </Link>
          </li>
          <li className={`sidebar-item ${getActiveItem() === 'courses' ? 'active' : ''}`}>
            <Link to="/learn" className="sidebar-link" onClick={onToggle}>
              <BookOpen className="sidebar-icon" />
              <span className="sidebar-text">Learn</span>
            </Link>
          </li>
          
          <li className={`sidebar-item ${getActiveItem() === 'quiz' ? 'active' : ''}`}>
            <a 
              href="https://quiz-app-jov2.onrender.com" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="sidebar-link"
            >
              <PenTool className="sidebar-icon" />
              <span className="sidebar-text">Take Quiz</span>
            </a>
          </li>
          <li className={`sidebar-item ${getActiveItem() === 'doubts' ? 'active' : ''}`}>
            <Link to="/doubts" className="sidebar-link" onClick={onToggle}>
              <MessageCircle className="sidebar-icon" />
              <span className="sidebar-text">Post Doubt</span>
            </Link>
          </li>
          
          <li className="sidebar-item logout-item">
            <button onClick={handleLogout} className="sidebar-link logout-button">
              <LogOut className="sidebar-icon" />
              <span className="sidebar-text">Logout</span>
            </button>
          </li>
        </ul>

        
      </div>
    </>
  );
};

export default Sidebar;
